import styled from 'styled-components';

export const NewButtonContainer = styled.div`
  margin-bottom: 3.2rem;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
  }
`;

export const NewButton = styled.button`
  color: #000;
  width: 328px;
  height: 50px;
  background: transparent linear-gradient(90deg, #ffd503 0%, #ffdf22 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50px;
  opacity: 1;
  font-size: 19px;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
    height: 50px;
  }

  &:hover {
    filter: brightness(0.9);
  }
`;

export const NewButtonLabel = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  padding-left: 5px;
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;

  > h1 {
    color: #ffdf22;
  }
`;

export const CardContainer = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 4.2rem 6.2rem;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;

    gap: 2rem;
  }
`;

export const NoDataFound = styled.div`
  width: 100%;
  text-align: center;

  margin-top: 10%;

  p {
    font-size: 2rem;
    color: white;
  }
`;
